<app-form-requests        
    [indexList] = "indexList"
    [systemList] = "systemList"
    [propertiesList] = "propertiesList"
    [propBskList] = "propBskList"
    [customEditorList]="editorList"
    [groupList]="groupList"
    [userList]="userList"
    [resultList]="resultList"
    [request]="selectedRequest"
    [requestItemList]="requestItem"
    (onValidate)="validate($event)"
    (onCancel)="cancel($event)"
    (onDelete)="delete($event)">
</app-form-requests>
